import script from "./WorkInstructionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkInstructionTab.vue?vue&type=script&setup=true&lang=js"

import "./WorkInstructionTab.vue?vue&type=style&index=0&id=70d2db4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d2db4e"]])

export default __exports__